import React from 'react';

export function SubmitErrors({ errors }: { errors: any }) {
    if (!errors) {
        return null;
    }

    let message;
    if (errors) {
        if (Object.keys(errors).length === 1) {
            message = errors[Object.keys(errors)[0]];
        } else {
            message = (
                <ul>
                    {Object.keys(errors).map(key => (
                        <li key={key}>{errors[key]}</li>
                    ))}
                </ul>
            );
        }
    } else {
        message = '';
    }

    return <div className="form-error">{message}</div>;
}
